import DocumentIndex from '@/views/fm/management/documents/Index'
import DocumentDetail from '@/views/fm/management/documents/Detail'
import DocumentTrigger from '@/views/fm/management/documents/Trigger'

export default
    [
        {
            name: 'fmmanagement:index',
            path: '/fmmanagement',
            component: {
                template: '<div><router-view /></div>'
            },
            children: [
                {
                    name: `documents:index`,
                    path: `documents`,
                    component: DocumentIndex,
                    
                },
                {
                    name: `documents:detail`,
                    path: `documents/:documentId`,
                    component: DocumentDetail
                },
                {
                    name: `documents:trigger`,
                    path: `documents/:documentId/:triggerId`,
                    component: DocumentTrigger
                }             
            ]
        }
    ]